<!-- Make a component that makes a chart legend from an array of obj with colors and labels -->

<script lang="ts">
  let { categoryKey, lineColours, legendLabels } = $props();

  const legendLabel = (categoryVal: string) => {
    const label = legendLabels?.find((l) => l[categoryKey] === categoryVal);
    return label ? label.label : categoryVal;
  };
</script>

<div class="legend">
  {#each lineColours as lineColour}
    <div class="legend-item">
      <div class="color-box" style="background-color:{lineColour.colour}"></div>
      <span>{legendLabel(lineColour[categoryKey])}</span>
    </div>
  {/each}
</div>

<style lang="scss">
  @use '@reuters-graphics/graphics-components/dist/scss/mixins' as mixins;

  // Style legend
  .legend {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    margin: 15px auto 1rem auto;
    max-width: var(--normal-column-width, 660px);

    .legend-item {
      display: flex;
      align-items: center;
      gap: 0.25rem;
      font-size: 14px;
      font-weight: 300;

      .color-box {
        width: 15px;
        height: 4px;
      }
    }
  }
</style>
